<div class="spa-page" [ngClass]="{ padding: padding }" id="{{ pageId }}">
  @if (title || titleText() || buttonIcon || subtitle) {
    <div class="spa-page__head">
      <div class="spa-page__title-and-button">
        @if (buttonIcon) {
          <chd-icon-button
            data-testid="back_to_search_page_button"
            [ariaLabel]="'page.back-to-search' | transloco"
            [icon]="buttonIcon"
            (clicked)="onClick()"
          />
        }
        <div class="spa-page__title">{{ title || titleText() }}</div>
      </div>
      @if (subtitle) {
        <div class="spa-page__subtitle">{{ subtitle }}</div>
      }
    </div>
  }

  <div class="spa-page__body">
    <ng-content></ng-content>
    <ng-content select="div[role=secondary]"></ng-content>
  </div>
</div>
